/**
 * The pure rules of the stage measurement, which the stage atoms and `useStageLayout` share.
 */

import type { StageLayout } from '@/types/panels';

export const PHONE_BREAKPOINT = 640;
// Stage width assumed where there is no window to measure.
export const FALLBACK_STAGE_WIDTH_PX = 1280;

const getMeasuredWidth = (value: number): number => (
    Number.isFinite(value) && value > 0 ? value : 0
);

export function calcStageLayout(stageWidth: number, windowWidth: number): StageLayout {
    return {
        stageWidth: getMeasuredWidth(stageWidth),
        isPhone: windowWidth < PHONE_BREAKPOINT,
    };
}
